<i18n>
{
  "fr": {
    "configuratorLayerEditorModalTextToolbar": {
      "action": {
        "bold": "Gras",
        "italic": "Italique",
        "underlined": "Souligné"
      },
      "text": {
        "placeholder": "Saisissez votre texte"
      },
      "typoSelect": {
        "placeholder": "Sélectionnez une police d'écriture"
      }
    }
  }
}
</i18n>

<template>
  <div class="configurator-layer-editor-modal-text-toolbar">
    <div
      class="configurator-layer-editor-modal-text-toolbar__row configurator-layer-editor-modal-text-toolbar__row--with-padding"
    >
      <div
        :class="[
          'configurator-layer-editor-modal-text-toolbar__row-item',
          'configurator-layer-editor-modal-text-toolbar__text-input-wrapper',
          {
            'configurator-layer-editor-modal-text-toolbar__text-input-wrapper--is-focused':
              isTextInputFocused,
          },
        ]"
      >
        <div
          class="configurator-layer-editor-modal-text-toolbar__text-input-prepend"
        ></div>
        <input
          ref="textInput"
          v-model.trim="value"
          type="text"
          class="configurator-layer-editor-modal-text-toolbar__text-input"
          :placeholder="
            $t('configuratorLayerEditorModalTextToolbar.text.placeholder')
          "
          :aria-label="
            $t('configuratorLayerEditorModalTextToolbar.text.placeholder')
          "
          required
          @focus="isTextInputFocused = true"
          @blur="isTextInputFocused = false"
        />
      </div>
    </div>

    <div class="configurator-layer-editor-modal-text-toolbar__row">
      <div
        class="configurator-layer-editor-modal-text-toolbar__row-item configurator-layer-editor-modal-text-toolbar__typo-select-wrapper"
      >
        <select
          v-model="localTypoId"
          name="typoId"
          class="configurator-layer-editor-modal-text-toolbar__typo-select"
          required
        >
          <option
            v-if="!localTypoId"
            :value="undefined"
            selected
            v-text="
              $t(
                'configuratorLayerEditorModalTextToolbar.typoSelect.placeholder'
              )
            "
          ></option>
          <option
            v-for="typo in typoList"
            :key="typo.id"
            :value="typo.id"
            v-text="ucFirst(typo.name)"
          ></option>
        </select>
      </div>

      <ConfiguratorLayerEditorModalToolbarColorPickerItem
        v-if="colorPicker"
        v-model="localColor"
        class="configurator-layer-editor-modal-text-toolbar__row-item"
      />

      <ConfiguratorLayerEditorModalToolbarToogleItem
        v-model="localBold"
        name="bold"
        :label="$t('configuratorLayerEditorModalTextToolbar.action.bold')"
        modifier="bold"
        class="configurator-layer-editor-modal-text-toolbar__row-item"
      />

      <ConfiguratorLayerEditorModalToolbarToogleItem
        v-model="localItalic"
        name="italic"
        :label="$t('configuratorLayerEditorModalTextToolbar.action.italic')"
        modifier="italic"
        class="configurator-layer-editor-modal-text-toolbar__row-item"
      />

      <ConfiguratorLayerEditorModalToolbarToogleItem
        v-model="localUnderlined"
        name="underlined"
        :label="$t('configuratorLayerEditorModalTextToolbar.action.underlined')"
        modifier="underlined"
        class="configurator-layer-editor-modal-text-toolbar__row-item"
      />
    </div>
  </div>
</template>

<script>
import ConfiguratorLayerEditorModalToolbarToogleItem from './ConfiguratorLayerEditorModalToolbarToogleItem';
import { ucFirst } from '../../../../utils/String';
import ConfiguratorLayerEditorModalToolbarColorPickerItem from './ConfiguratorLayerEditorModalToolbarColorPickerItem';

export default {
  name: 'ConfiguratorLayerEditorModalTextToolbar',
  components: {
    ConfiguratorLayerEditorModalToolbarColorPickerItem,
    ConfiguratorLayerEditorModalToolbarToogleItem,
  },
  props: {
    typoList: {
      type: Array,
      default: () => [],
    },
    typoId: {
      type: Number,
      default: undefined,
    },
    bold: Boolean,
    underlined: Boolean,
    italic: Boolean,
    text: {
      type: String,
      default: undefined,
    },
    color: {
      type: String,
      default: undefined,
    },
    colorPicker: Boolean,
  },
  data() {
    return {
      isTextInputFocused: false,
    };
  },
  computed: {
    ...['bold', 'underlined', 'italic', 'typoId', 'color'].reduce(
      (acc, prop) => {
        acc[`local${ucFirst(prop)}`] = {
          get() {
            return this[prop];
          },
          set(v) {
            this.$emit(`update:${prop}`, v);
          },
        };

        return acc;
      },
      {}
    ),
    value: {
      get() {
        return this.text;
      },
      set(value) {
        this.$emit('update:text', value);
      },
    },
  },

  async mounted() {
    await this.$nextTick();
    if (!this.typoId) {
      this.localTypoId = this.typoList[0].id;
    }
  },
  methods: {
    ucFirst,
    focusTextInput() {
      this.$refs.textInput.focus();
    },
  },
};
</script>

<style lang="scss" scoped>
.configurator-layer-editor-modal-text-toolbar {
  $border: solid 1px $color-gray-silver-light;
  $configurator-layer-editor-modal-text-toolbar-height: $configurator-zone-input-height;
  padding: 0.5em;
  border-top: $border;

  &__row {
    display: flex;
    border: $border;
    margin-bottom: 0.5em;
    height: $configurator-layer-editor-modal-text-toolbar-height;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__typo-select-wrapper {
    position: relative;
    flex: 1;
    min-width: 0;
    display: flex;

    &::after {
      @extend %icon;
      @extend %icon--arrow-fill-bottom;
      position: absolute;
      font-size: 0.5em;
      right: 1em;
      top: 50%;
      transform: translateY(-50%);
      pointer-events: none;
    }
  }

  &__typo-select {
    display: block;
    flex: 1;
    min-width: 0;
    width: 100%;
    appearance: none;
    padding: 0.25em 1em 0.25em 0.5em;
    font-size: inherit;
    font-family: inherit;
    color: inherit;
    font-weight: inherit;
    background: inherit;
    border: 0;
    line-height: inherit;
    margin: 0;
    box-sizing: inherit;
    border-radius: 0;
    cursor: pointer;
  }

  &__row-item {
    border-right: $border;
    display: flex;

    &:last-child {
      border-right: 0;
    }
  }

  &__text-input-wrapper {
    flex: 1;
    min-width: 0;
    display: flex;

    &--is-focused {
      outline: 2px solid $color-red-razzmatazz;
    }
  }

  &__text-input-prepend {
    display: flex;
    justify-content: center;
    align-items: center;
    border-right: $border;
    min-width: $configurator-layer-editor-modal-text-toolbar-height;

    &::before {
      content: 'T';
      font-family: 'Times New Roman', serif;
      font-size: 1.5em;
      color: $color-gray-silver;
    }
  }

  &__text-input {
    flex: 1;
    min-width: 0;
    padding: 0.5em;
    border: 0;
  }
}
</style>
